import { socket } from '../..';
import { agentTestEvents } from '@shared/services/agent-test';

export const handleAgentTestMessage = () => {
  return socket.onMessage('AGENT_TEST_MESSAGE', (payload) => {
    agentTestEvents.emitMessage(payload);
  });
};
